import React from 'react'

const BrandedTracking = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={40}
                height={40}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        fill="#c8effe"
                        d="M510 365.679H224.656v43.577h280.379a6.965 6.965 0 0 0 6.965-6.965v-35.612z"
                        opacity={1}
                        data-original="#c8effe"
                    />
                    <path
                        fill="#faea5e"
                        d="M413.489 259.002v107.677H512v-54.826c0-2.806-.678-5.57-1.976-8.057l-18.499-35.44a17.41 17.41 0 0 0-15.435-9.355h-62.601z"
                        opacity={1}
                        data-original="#faea5e"
                        className=""
                    />
                    <path
                        fill="#ffffff"
                        d="M440.918 339.25v-52.819h29.101l14.552 27.88v24.939z"
                        opacity={1}
                        data-original="#ffffff"
                    />
                    <path
                        fill="#f2fbff"
                        d="M440.918 286.431h20.835v52.818h-20.835z"
                        opacity={1}
                        data-original="#f2fbff"
                    />
                    <path
                        fill="#ffd600"
                        d="M484.571 346.75h-43.653a7.499 7.499 0 0 1-7.5-7.5v-52.818c0-4.143 3.357-7.5 7.5-7.5h29.101a7.499 7.499 0 0 1 6.648 4.029l14.553 27.88a7.49 7.49 0 0 1 .852 3.471v24.938a7.501 7.501 0 0 1-7.501 7.5zm-36.153-15h28.653v-15.599l-11.599-22.22h-17.055v37.819z"
                        opacity={1}
                        data-original="#ffd600"
                    />
                    <circle
                        cx="450.262"
                        cy="412.797"
                        r="26.652"
                        fill="#596c76"
                        opacity={1}
                        data-original="#596c76"
                        className=""
                    />
                    <path
                        fill="#465a61"
                        d="M444.496 412.797c0-11.013 6.68-20.464 16.209-24.526a26.568 26.568 0 0 0-10.443-2.126c-14.72 0-26.652 11.932-26.652 26.652 0 14.719 11.932 26.652 26.652 26.652a26.55 26.55 0 0 0 10.443-2.126c-9.528-4.062-16.209-13.514-16.209-24.526z"
                        opacity={1}
                        data-original="#465a61"
                    />
                    <circle
                        cx="310.564"
                        cy="412.797"
                        r="26.652"
                        fill="#596c76"
                        opacity={1}
                        data-original="#596c76"
                        className=""
                    />
                    <path
                        fill="#465a61"
                        d="M304.91 412.797c0-10.991 6.654-20.425 16.153-24.501a26.554 26.554 0 0 0-10.499-2.151c-14.719 0-26.652 11.932-26.652 26.652 0 14.719 11.933 26.652 26.652 26.652a26.55 26.55 0 0 0 10.499-2.151c-9.499-4.076-16.153-13.51-16.153-24.501z"
                        opacity={1}
                        data-original="#465a61"
                    />
                    <path
                        fill="#596c76"
                        d="M237.777 386.145c-4.772 0-9.246 1.26-13.12 3.456v46.391a26.521 26.521 0 0 0 13.12 3.456c14.719 0 26.652-11.932 26.652-26.652s-11.933-26.651-26.652-26.651z"
                        opacity={1}
                        data-original="#596c76"
                        className=""
                    />
                    <path
                        fill="#465a61"
                        d="M232.343 412.797c0-10.948 6.604-20.35 16.043-24.451a26.554 26.554 0 0 0-10.609-2.201c-4.771 0-9.246 1.26-13.12 3.456v46.391a26.521 26.521 0 0 0 13.12 3.456c3.771 0 7.357-.788 10.609-2.201-9.44-4.1-16.043-13.502-16.043-24.45z"
                        opacity={1}
                        data-original="#465a61"
                    />
                    <path
                        fill="#80d261"
                        d="M410.007 196.058H224.656v170.621h188.833V199.54a3.482 3.482 0 0 0-3.482-3.482z"
                        opacity={1}
                        data-original="#80d261"
                        className=""
                    />
                    <path
                        fill="#faea5e"
                        d="M368.215 257.499H224.656v47.738h143.559a5.076 5.076 0 0 0 5.076-5.076v-37.587a5.076 5.076 0 0 0-5.076-5.075z"
                        opacity={1}
                        data-original="#faea5e"
                        className=""
                    />
                    <path
                        fill="#ffd600"
                        d="M248.584 300.162v-37.588a5.075 5.075 0 0 1 5.075-5.075h-29.003v47.738h29.003a5.074 5.074 0 0 1-5.075-5.075z"
                        opacity={1}
                        data-original="#ffd600"
                    />
                    <path
                        fill="#9facba"
                        d="M215.66 410.006H10.27l-2.77 1.097v52.288c0 6.06 4.912 10.972 10.972 10.972h188.713c6.059 0 10.972-4.912 10.972-10.972v-52.288z"
                        opacity={1}
                        data-original="#9facba"
                    />
                    <path
                        fill="#8d9ca8"
                        d="M50.109 463.391v-52.288H7.5v52.288c0 6.06 4.912 10.972 10.972 10.972H61.08c-6.059 0-10.971-4.913-10.971-10.972z"
                        opacity={1}
                        data-original="#8d9ca8"
                    />
                    <path
                        fill="#596c76"
                        d="M82.108 410.006v2.194c0 16.967 13.754 30.721 30.721 30.721s30.721-13.754 30.721-30.721v-2.194z"
                        opacity={1}
                        data-original="#596c76"
                        className=""
                    />
                    <path
                        fill="#99e6fc"
                        d="M207.185 115.243h-37.227a63.237 63.237 0 0 1-3.917 8.061l-49.924 86.472c-.687 1.188-1.916 1.898-3.289 1.898s-2.603-.71-3.289-1.898l-49.924-86.472a63.237 63.237 0 0 1-3.917-8.061H18.472c-6.06 0-10.972 4.912-10.972 10.972v284.888h210.656V126.215c0-6.06-4.912-10.972-10.971-10.972z"
                        opacity={1}
                        data-original="#99e6fc"
                        className=""
                    />
                    <path
                        fill="#62dbfb"
                        d="M55.698 115.243H18.472c-6.06 0-10.972 4.912-10.972 10.972v284.888h42.609V126.215c0-4.296 2.474-8.004 6.07-9.806a62.102 62.102 0 0 1-.481-1.166z"
                        opacity={1}
                        data-original="#62dbfb"
                        className=""
                    />
                    <path
                        fill="#596c76"
                        d="M207.185 107.743h-34.757a62.373 62.373 0 0 1-6.074 15h40.831a3.477 3.477 0 0 1 3.472 3.472V463.39a3.477 3.477 0 0 1-3.472 3.473H18.472A3.477 3.477 0 0 1 15 463.39V126.215a3.477 3.477 0 0 1 3.472-3.472h40.831a62.373 62.373 0 0 1-6.074-15H18.472C8.286 107.743 0 116.029 0 126.215V463.39c0 10.186 8.286 18.473 18.472 18.473h188.713c10.186 0 18.472-8.287 18.472-18.473V126.215c-.001-10.186-8.287-18.472-18.472-18.472z"
                        opacity={1}
                        data-original="#596c76"
                        className=""
                    />
                    <g fill="#01c0fa">
                        <path
                            d="M156.211 189.935h-28.639l-8.66 15h37.299c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM98.084 189.935H69.445c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h37.299z"
                            fill="#01c0fa"
                            opacity={1}
                            data-original="#01c0fa"
                        />
                    </g>
                    <path
                        fill="#fd4755"
                        d="m116.983 210.276 49.924-86.471c24.035-41.63-6.009-93.668-54.079-93.668s-78.115 52.038-54.079 93.668l49.924 86.471c1.847 3.199 6.464 3.199 8.31 0z"
                        opacity={1}
                        data-original="#fd4755"
                    />
                    <path
                        fill="#fb2b3a"
                        d="M100.719 123.805C80.422 88.65 98.691 46.074 133.813 33.68c-6.469-2.283-13.509-3.543-20.985-3.543-48.07 0-78.115 52.038-54.079 93.668l49.924 86.471c1.847 3.199 6.464 3.199 8.31 0l16.83-29.151z"
                        opacity={1}
                        data-original="#fb2b3a"
                        className=""
                    />
                    <circle
                        cx="112.828"
                        cy="95.068"
                        r="22.369"
                        fill="#ffffff"
                        opacity={1}
                        data-original="#ffffff"
                    />
                    <path
                        fill="#f2fbff"
                        d="M111.262 95.068c0-8.598 4.853-16.058 11.967-19.803a22.261 22.261 0 0 0-10.401-2.566c-12.354 0-22.369 10.015-22.369 22.369s10.015 22.369 22.369 22.369c3.756 0 7.294-.93 10.401-2.566-7.113-3.745-11.967-11.205-11.967-19.803z"
                        opacity={1}
                        data-original="#f2fbff"
                    />
                    <path
                        fill="#ea9b58"
                        d="M171.437 241.809h-41.803l-1 1.334v23.73a2.047 2.047 0 0 1-2.045 2.045H99.068a2.048 2.048 0 0 1-2.046-2.045v-23.758l-1-1.307H54.219a5.075 5.075 0 0 0-5.075 5.076v117.218a5.075 5.075 0 0 0 5.075 5.075h117.218a5.075 5.075 0 0 0 5.075-5.075V246.884a5.074 5.074 0 0 0-5.075-5.075z"
                        opacity={1}
                        data-original="#ea9b58"
                        className=""
                    />
                    <path
                        fill="#d88a55"
                        d="M74 364.102V246.884a5.076 5.076 0 0 1 5.075-5.076H54.219a5.075 5.075 0 0 0-5.075 5.076v117.218a5.075 5.075 0 0 0 5.075 5.075h24.856A5.075 5.075 0 0 1 74 364.102z"
                        opacity={1}
                        data-original="#d88a55"
                        className=""
                    />
                    <path
                        fill="#fd4755"
                        d="M96.023 241.809v25.064a3.045 3.045 0 0 0 3.045 3.045h27.521a3.045 3.045 0 0 0 3.045-3.045v-25.064z"
                        opacity={1}
                        data-original="#fd4755"
                    />
                    <path
                        fill="#fb2b3a"
                        d="M109 266.873v-25.064H96.023v25.064a3.045 3.045 0 0 0 3.045 3.045h12.977a3.045 3.045 0 0 1-3.045-3.045z"
                        opacity={1}
                        data-original="#fb2b3a"
                        className=""
                    />
                    <path
                        fill="#d88a55"
                        d="m132.705 300.313-14.198-16.457a7.503 7.503 0 0 0-11.358 0l-14.197 16.457a7.5 7.5 0 0 0 11.357 9.799l1.019-1.181v15.903c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5V308.93l1.02 1.182a7.483 7.483 0 0 0 5.682 2.601 7.501 7.501 0 0 0 5.675-12.4zM128.225 353.25H97.433c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h30.792c4.143 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z"
                        opacity={1}
                        data-original="#d88a55"
                        className=""
                    />
                    <circle
                        cx="189.201"
                        cy="141.097"
                        r="7.5"
                        fill="#01c0fa"
                        opacity={1}
                        data-original="#01c0fa"
                    />
                </g>
            </svg>

        </>
    )
}

export default BrandedTracking